var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-pagination"},[_c('button',{on:{"click":_vm.emitPrevPage}},[_vm._v(" < ")]),_c('span',{staticClass:"page-number"},[_vm._v(_vm._s(_vm.page))]),_c('button',{on:{"click":_vm.emitNextPage}},[_vm._v(" > ")])])}
var staticRenderFns = []

export { render, staticRenderFns }